// import AdvancedSelect from '@myena/advanced-select';
import _ from 'lodash'
import LoadingBtn from '../../common/ui/loading_btn.vue';

export default {
	data(){
		return {}
	},
	methods:{
		goToConnection(){
			history.pushState({}, '', window.location.pathname);
			this.$store.commit('UI_SET_MODAL', { modal: 'connection' });
		}		
	},
	computed:{
		
	},
	components: {
		LoadingBtn
	}
}
